import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import { fadeSliderOptions, innerSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';
import { tabsSliderOptions } from '../sliders/sliders';
import { equalTableCols } from '../equalTableCols';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'crm';

  const crmAffiliatesSlider = initSlider('[data-affiliates-slider]', fadeSliderOptions);

  /*  */

  const crmPlansSlider = initSlider('[data-crm-plans-slider]', crmPlansSliderOptions);
  const crmPlansOverviewSlider = initSlider('[data-crm-plans-overview-slider]', {
    ...crmPlansOverviewSliderOptions,
    thumbs: {
      swiper: crmPlansSlider,
      autoScrollOffset: 0.5,
    },
  });
  crmPlansSlider.on('realIndexChange', (swiper) => swiper.slideTo(swiper.realIndex));
  crmPlansOverviewSlider.on('realIndexChange', (swiper) => swiper.slideTo(swiper.realIndex));

  /*  */

  const crmRoomTabsSlider = initSlider('[data-crm-room-tabs-slider]', tabsSliderOptions);
  const crmRoomSlider = initSlider('[data-crm-room-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: crmRoomTabsSlider,
      autoScrollOffset: 0.5,
    },
    allowTouchMove: false,
  });

  /*  */

  const crmBackofficeTabsSlider = initSlider('[data-crm-backoffice-tabs-slider]', tabsSliderOptions);
  const crmBackofficeSlider = initSlider('[data-crm-backoffice-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: crmBackofficeTabsSlider,
      autoScrollOffset: 0.5,
    },
    allowTouchMove: false,
  });

  /*  */

  const crmAdminTabsSlider = initSlider('[data-crm-admin-tabs-slider]', tabsSliderOptions);
  const crmAdminSlider = initSlider('[data-crm-admin-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: crmAdminTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  /*  */

  const crmSalesTabsSlider = initSlider('[data-crm-sales-tabs-slider]', tabsSliderOptions);
  const crmSalesSlider = initSlider('[data-crm-sales-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: crmSalesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  /*  */

  const innerSliders = initSlider('[data-inner-slider]', innerSliderOptions);
  innerSliders.forEach((slider) => {
    slider.on('slideChangeTransitionStart', (swiper) => changeActiveSlide(swiper, PAGE));
  });

  /*  */

  [crmRoomTabsSlider, crmBackofficeTabsSlider, crmAdminTabsSlider, crmSalesTabsSlider].forEach((slider) => {
    slider.on('click', (swiper) => {
      // innerSliders.forEach(swiper => swiper.slideTo(0));
      changeActiveSlide(swiper, PAGE);
    });
  });
  [crmRoomSlider, crmBackofficeSlider, crmAdminSlider, crmSalesSlider].forEach((slider) => {
    slider.on('slideChangeTransitionStart', (swiper) => {
      // innerSliders.forEach(swiper => swiper.slideTo(0));
      changeActiveSlide(swiper, PAGE);
    });
  });

  /*  */

  const crmPlansTable = document.querySelector('[data-table]');
  equalTableCols(crmPlansTable);

  ['resize', 'orientationchange'].forEach((e) => {
    window.addEventListener(e, () => {
      equalTableCols(crmPlansTable);
    });
  });
});

const crmPlansSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 24,
  simulateTouch: false,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    601: {
      slidesPerView: 2,
    },
  },
};

const crmPlansOverviewSliderOptions = {
  slidesPerView: 1,
  simulateTouch: false,

  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    601: {
      slidesPerView: 2,
    },
  },
};
